// noinspection JSUnusedGlobalSymbols

export enum ProgramCodes {
  DB30 = 'DB30',
  MP30 = 'MP30',
  PEOC = 'PEOC',
  PTRAIN = 'PTRAIN',
  LEMPG = 'LEMPG',
  MITG = 'MITG',
  SERCLEPC = 'SERCLEPC',
  PTRACK = 'PTRACK',
  EGRESS = 'EGRESS',
  DMA = 'DMA',
  DMAM = 'DMAM',
  REP = 'REP',
  VEOC = 'VEOC',
  HURH = 'HURH',
  GIS = 'GIS',
  DECON = 'DECON',
}

export enum ProgramTitles {
  DB30 = 'Palmetto EOC',
  MP30 = 'Palmetto Map',
  PEOC = 'Classic Palmetto EOC',
  PTRAIN = 'Classic Palmetto Training',
  LEMPG = 'LEMPG',
  MITG = 'Mitigation',
  SERCLEPC = 'SERC/LEPC',
  PTRACK = 'Patient Tracking',
  EGRESS = 'Check In/Check Out',
  DMA = 'Main Damage Assessment',
  DMAM = 'Mobile Damage Assessment',
  REP = 'Radiological Emergency Preparedness',
  VEOC = 'Virtual EOC',
  HURH = 'Hurricane Hub',
  GIS = 'GIS Hub',
  DECON = 'REP Reception Centers',
}

export enum ProgramSubTitles {
  DB30 = 'The Palmetto Dashboard is a comprehensive platform designed to serves as a one-stop dashboard for monitoring.',
  MP30 = 'The Palmetto Map application within the South Carolina Emergency Management system.',
  PEOC = 'South Carolina’s Common Operating Picture, the system of record for real-world events',
  PTRAIN = 'Replica of the Palmetto site, available to anyone with a Palmetto user account',
  LEMPG = 'Documents each step of the Local Emergency Management Performance Grant (LEMPG) process',
  MITG = 'Lifecycle of applicant’s mitigation plan and the details for mitigation projects',
  SERCLEPC = 'Gathers annual data from Local Emergency Planning Committees (LEPC) across the state and the State Emergency Planning Committee (SERC)',
  PTRACK = 'A mass causality program that assigns triage patients to an EMS vehicle and records which hospital the patients are dropped off',
  EGRESS = 'Create a QR code and link to record attendance or individuals checking into and out of an EOC, command post, training, feeding mission, etc.',
  DMA = 'Gathers IA and PA entries, displays entries on a map, and produces FEMA reports',
  DMAM = 'For use by anyone going out in the field to gather IA and PA data after a real world disaster',
  REP = 'Tracks equipment calibration due dates, plant exercises, annual letter of certification workflow',
  VEOC = 'A site to help facilitate communication between EOC team members that are working in various locations',
  HURH = 'The Hurricane Hub serves as a one-stop-shop for hurricane preparedness information and coordination. Certain pages will only be visible during a tropical event.',
  GIS = 'The SCEMD GIS Hub serves as a one-stop shop for statewide GIS information.',
  DECON = 'The Decontamination Hub serves as a one-stop shop for decontamination information.',
}

export enum SiteStatusCodes {
  ACTIVE = 'ACT',
  REQUEST = 'REQ',
  DENY = 'DNY',
  SUSPEND = 'SUS',
}

export enum ProgramSites {
  PEOC = 'https://www.palmettoeoc.com',
  LEMPG = 'https://lempg.palmettoeoc.com',
  MITG = 'https://mitigation.palmettoeoc.com',
  SERCLEPC = 'https://lepc.palmettoeoc.com',
  PTRACK = 'https://emt.palmettoeoc.com',
  PTRAIN = 'https://training.palmettoeoc.com',
  EGRESS = 'https://checkin.cloudeoc.com',
  DMA = 'https://damage.palmettoeoc.com',
  DMAM = 'https://dma.palmettoeoc.com',
  REP = 'https://rep.palmettoeoc.com',
  VEOC = 'https://veoc.palmettoeoc.com',
  HURH = 'https://experience.arcgis.com/experience/925d8c5313f34bf5aa49215a91121176',
  GIS = 'https://gis-scemd.hub.arcgis.com',
  DECON = 'https://decon.cloudeoc.com',
  DB30 = 'https://dashboard.cloudeoc.com',
  MP30 = 'https://map.cloudeoc.com',
}

export default ProgramCodes;
